import { render } from "./Ending.vue?vue&type=template&id=0a1cf37c&scoped=true"
const script = {}

import "./Ending.vue?vue&type=style&index=0&id=0a1cf37c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a1cf37c"

export default script